import { z } from "zod";
import { employmentTypeSchema, workModeSchema } from "@/shared/membership/directory.schema";

export const updateMembershipHrSchema = z
  .object({
    title: z.string().max(120).optional(),
    hireDate: z.string().optional(),
    employmentType: employmentTypeSchema.nullable().optional(),
    workMode: workModeSchema.nullable().optional(),
    location: z.string().max(120).optional(),
    employeeId: z.string().max(64).optional(),
    departmentId: z.string().nullable().optional(),
  })
  .strict();
export type UpdateMembershipHrInput = z.infer<typeof updateMembershipHrSchema>;

export const updateMembershipHrResponseSchema = z.object({
  membershipId: z.string(),
  title: z.string().nullable(),
  hireDate: z.string().nullable(),
  employmentType: employmentTypeSchema.nullable(),
  workMode: workModeSchema.nullable(),
  location: z.string().nullable(),
  employeeId: z.string().nullable(),
  version: z.number().int(),
});
export type UpdateMembershipHrResponse = z.infer<typeof updateMembershipHrResponseSchema>;
